"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionResults = void 0;
const adaptivecards_1 = require("adaptivecards");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const QuestionSettingsInfoBar_1 = require("../components/QuestionSettingsInfoBar");
const QuestionNominalResults_1 = require("./QuestionNominalResults");
const QuestionOrdinalResult_1 = require("./QuestionOrdinalResult");
const QuestionResultsOpenEnded_1 = require("./QuestionResultsOpenEnded");
const QuestionResults = (question, responses, anonymityLevel, applicationType, options) => {
    const { showTitle, maxResultsCount, containerProps, hideSettings } = options;
    const questionContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, containerProps);
    if (showTitle) {
        questionContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: question.label,
            size: adaptivecards_1.TextSize.Large,
            weight: adaptivecards_1.TextWeight.Bolder,
            wrap: true,
        }));
        if (!hideSettings) {
            const optionList = (0, QuestionSettingsInfoBar_1.QuestionSettingsInfoBar)(question);
            if (optionList) {
                questionContainer.addItem(optionList);
            }
        }
    }
    if (maxResultsCount !== undefined) {
        let text;
        switch (question.questionType) {
            case "open-ended":
                if (responses.length > maxResultsCount) {
                    text = `First ${maxResultsCount} Responses`;
                }
                break;
            case "nominal":
            case "ordinal":
                //Ordinal and Nominal both have the same choices array property
                const ordinalQuestion = question;
                if (ordinalQuestion.choices.length > maxResultsCount &&
                    ordinalQuestion.renderAs !== "nps") {
                    text = `Top ${maxResultsCount} Choices of ${ordinalQuestion.choices.length}`;
                }
                break;
            default:
                break;
        }
        if (text) {
            questionContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
                text,
                weight: adaptivecards_1.TextWeight.Bolder,
                wrap: true,
            }));
        }
    }
    switch (question.questionType) {
        case "open-ended":
            questionContainer.addItem((0, QuestionResultsOpenEnded_1.QuestionResultsOpenEnded)(responses, question, options.autolinkIntegrations, maxResultsCount));
            break;
        case "nominal":
            questionContainer.addItem((0, QuestionNominalResults_1.QuestionNominalResults)(responses, question, anonymityLevel, options.hideSummaryTotal, applicationType, maxResultsCount, options.currentUserId));
            break;
        case "ordinal":
            questionContainer.addItem((0, QuestionOrdinalResult_1.QuestionOrdinalResults)(responses, question, anonymityLevel, applicationType, maxResultsCount));
            break;
        default:
            throw new Error(`unknown question type ${question.questionType}`);
    }
    return questionContainer;
};
exports.QuestionResults = QuestionResults;
//# sourceMappingURL=QuestionResults.js.map